import { Injectable, inject } from '@angular/core';

import { NotificationTypeEnum } from '@nexweb/shared/data-access/mdd';
import { BaseSignalR, SignalRHubNames } from '@nexweb/shared/signalr-helper';

import { ErrorNotificationService } from './error-notification.service';
import { SystemNotificationService } from './system-notification.service';
import { UserAlertService, UserAlertPayload } from './user-alert.service';

@Injectable({
  providedIn: 'root',
})
export class SystemMessagingHubService extends BaseSignalR {
  private errorNotificationService = inject(ErrorNotificationService);
  private systemNotificationService = inject(SystemNotificationService);
  private userAlertService = inject(UserAlertService);

  constructor() {
    super(SignalRHubNames.systemMessaging);
  }

  protected initEvents(): void {
    this.hubConnection.on(
      'NotifyUser',
      (
        messageId: number,
        messageText: string,
        notificationComponent: NotificationTypeEnum,
        // eslint-disable-next-line @typescript-eslint/naming-convention -- payload keys mirror the backend PascalCase contract
        parameters: { ErrorMessage: string; BidId: number } & UserAlertPayload,
      ) => {
        switch (notificationComponent) {
          case NotificationTypeEnum.systemNotification:
            this.systemNotificationService.show(messageText);
            break;
          case NotificationTypeEnum.errorNotification:
            this.errorNotificationService.show(parameters.ErrorMessage);
            break;
          case NotificationTypeEnum.userAlert:
            this.userAlertService.show(parameters);
            break;
          default:
            break;
        }
      },
    );
  }
}
